module.exports = __webpack_public_path__ + "static/media/physiotherapy-primary.d8450b6d.jpg";